import { connect } from 'react-redux'
import {
  sendConfirmationEmail,
  checkEmailVerification
} from 'redux/modules/auth'
import {
  updateBoarding,
  updateConfig,
  stepComplete,
  checkAccountAvailability,
  createHiboutikAccount,
  updateTableTypeSettings,
  checkAccountCreation,
  updatePricing,
  updateNavigationMenu,
  updateSettingsStep,
  boardingFinished
} from 'redux/modules/boarding'
import { showModal } from 'redux/modules/modals'
import BoardingComponent from '../components/BoardingComponent'

const mapActionCreators = {
  updateBoarding,
  updateConfig,
  checkEmailVerification,
  sendConfirmationEmail,
  stepComplete,
  checkAccountAvailability,
  createHiboutikAccount,
  updateTableTypeSettings,
  updatePricing,
  updateNavigationMenu,
  updateSettingsStep,
  boardingFinished,
  checkAccountCreation,
  showModal
}

const mapStateToProps = state => ({
  auth: state.auth,
  boarding: state.boarding
})

export default connect(mapStateToProps, mapActionCreators)(BoardingComponent)



// WEBPACK FOOTER //
// ./src/routes/Boarding/containers/BoardingContainer.js